"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/vastuullisuus/vastuullisuus.scss');
const index_1 = require("./index");
const vastuullisuus_1 = require("./Sites/vastuullisuus");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Import site specific scripts
(0, vastuullisuus_1.InitVastuullisuus)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)();
